export const calculateFlexShrink = (names: string[]): number[] => {
	const nameLengths = names.map((name) => (name === undefined ? 0 : name.length));
	const shrinkCoefficient = 0.2; // A smaller number will make the components shrink closer to a similar rate.
	return nameLengths.map((length) => Math.pow(length, shrinkCoefficient));
};
